import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid2,
  Stack,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useGetAllPMQuery } from "store/slices/apis/pmPackageSlice";
import { useEditKeyPMMutation } from "store/slices/apis/keyPMSlice";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import time from "assets/time.png";
import editLogo from "assets/EditIcon.svg";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import { IoIosSearch } from "react-icons/io";
import { usePermission } from "hooks/usePermission";
import { PM_VIEW } from "config";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const AllPM = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const pmViewAccess = usePermission(PM_VIEW);

  const [pageNumber, setPageNumber] = useState(1);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });
  const { projectId } = useParams();
  const {
    data: allPM,
    refetch,
    isLoading,
  } = useGetAllPMQuery({
    ProjectId: projectId,
    sortBy: "UpdatedAt",
    sortOrder: "desc",
    from: filters?.fromDate,
    to: filters?.toDate,
    page: pageNumber,
    pageSize: 10,
    search: searchQuery,
  });

  const [data, setData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [dialogRowId, setDialogRowId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [columns, setColumns] = useState([]);
  const [editKeyPM] = useEditKeyPMMutation();

  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  useEffect(() => {
    refetch();
  }, []);

  const clearSearch = () => {
    setSearchQuery("");
  };

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const cols = [
      // {
      //   name: "PM ID",
      //   field: "tag",
      //   renderer(params) {
      //     return (
      //       <Stack direction="row" spacing={1}>
      //         {params?.tag && (
      //           <Chip
      //             label={params?.tag}
      //             size="small"
      //             sx={{
      //               fontSize: "12px",
      //               "& .MuiChip-label": {
      //                 paddingLeft: "8px",
      //                 paddingRight: "8px",
      //                 fontWeight: 600,
      //               },
      //             }}
      //           />
      //         )}
      //       </Stack>
      //     );
      //   },
      // },
      {
        name: "PM Name",
        field: "pm",
      },
      {
        name: "Category",
        field: "category",
      },
      {
        name: "Owned / Hired",
        field: "owned",
        renderer(params) {
          return <>{params?.owned ? "Owned" : "Hired"}</>;
        },
      },
      {
        name: "Plan Deployment Date",
        field: "plannedDate",
        renderer(params) {
          return (
            <>
              {params?.plannedDate
                ? moment(params.plannedDate).format("DD/MM/YY")
                : "N.A."}
            </>
          );
        },
      },
      {
        name: "Actual Deployment Date",
        field: "actualDate",
        renderer: (row) => (
          <Box>
            <Grid2
              sx={{
                whiteSpace: "nowrap",
                color: "#474747",
                border: "none",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#F3F3F3",
                margin: "10px 20px 10px 0",
                border: "1px solid #D1D1D1 !important",
                borderRadius: "5px",
                maxWidth: "250px",
                padding: "10px !important",
                margin: "0 !important",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div style={{ height: "16px", width: "16px" }}>
                  <img src={time} alt="" />
                </div>
                {row?.actualDate ? (
                  <span>{moment(row.actualDate).format("DD/MM/YY")}</span>
                ) : (
                  ""
                )}
              </div>
              <Tooltip title="Edit Actual Deployment Date">
                <div
                  style={{
                    height: "16px",
                    width: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleEditClick(row)}
                >
                  <img src={editLogo} alt="" />
                </div>
              </Tooltip>
            </Grid2>

            {selectedRowId === row?.id && (
              <div
                style={{
                  position: "absolute",
                  background: "#fff",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
                  zIndex: 10,
                  right: "50px",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    key={selectedRowId}
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      actionBar: {
                        actions: [],
                      },
                    }}
                    sx={{
                      ".MuiPickersToolbar-root": {
                        display: "none",
                      },
                      ".MuiPickersLayout-root": {
                        marginLeft: "-125px",
                        marginTop: "-5px",
                        boxShadow: "0px 8px 16px -2px",
                      },
                      ".MuiPickersDay-root.Mui-selected": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiPickersDay-root.Mui-selected:hover": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiPickersDay-root:focus.Mui-selected": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiDialogActions-root": {
                        display: "none",
                      },
                    }}
                  />
                </LocalizationProvider>
                <Grid2
                  sx={{
                    textAlign: "end",
                    marginRight: "20px",
                    marginBottom: "30px",
                  }}
                >
                  <Button
                    onClick={handleCloseCalendar}
                    variant="outlined"
                    sx={{
                      color: theme?.customSettings?.themeColor,
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "none",
                      border: `1px solid ${theme?.customSettings?.themeColor}`,
                      marginRight: "10px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleDoneClick}
                    variant="contained"
                    sx={{
                      backgroundColor: theme?.customSettings?.themeColor,
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "none",
                    }}
                  >
                    Done
                  </Button>
                </Grid2>
              </div>
            )}

            <Dialog open={dialogRowId === row?.id} onClose={handleCloseDialog}>
              <DialogTitle
                sx={{
                  color: "#252525",
                  fontSize: "20px",
                  lineHeight: "24px",
                  fontWeight: 500,
                }}
              >
                Accept Changes
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080 " }} />
              </IconButton>
              <DialogContent>
                <Typography
                  sx={{
                    color: "#474747",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 400,
                  }}
                >
                  Are you sure you want to accept the changes? You can re edit
                  this later.
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  marginBottom: "20px",
                }}
              >
                <Button
                  onClick={handleCloseDialog}
                  variant="outlined"
                  sx={{
                    color: theme?.customSettings?.themeColor,
                    fontSize: "16px",
                    fontWeight: "500",
                    textTransform: "none",
                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmChange}
                  variant="contained"
                  sx={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "500",
                    textTransform: "none",
                    marginRight: "20px",
                  }}
                >
                  Accept Changes
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        ),
      },
      {
        name: "Action",
        field: "action",
        option: {},
      },
    ];

    setColumns(cols);
  }, [selectedRowId, selectedDate, dialogRowId]);

  // useEffect(() => {
  //   if (allPM?.data) {
  //     const tempData = allPM.data.map((item) => ({
  //       ...item,
  //     }));
  //     setData(tempData);
  //   }
  // }, [allPM?.data]);

  useEffect(() => {
    if (allPM?.data) {
      const tempData = allPM?.data.map((item) => ({ ...item }));
      if (searchQuery) {
        const filteredData = tempData?.filter(
          (item) =>
            item?.pm_number
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            item?.pm?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item?.category?.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setData(filteredData);
      } else {
        setData(tempData);
      }
    }
  }, [allPM?.data, searchQuery]);

  const handleEditClick = (row) => {
    setSelectedRowId(row?.id);
    setSelectedRowData(row);
    setSelectedDate(row?.actualDate ? dayjs(row.actualDate) : dayjs());
  };

  const handleCloseCalendar = () => {
    setSelectedRowId(null);
    setSelectedDate(null);
  };

  const handleDoneClick = () => {
    setDialogRowId(selectedRowId);
  };

  const handleCloseDialog = () => {
    setDialogRowId(null);
  };

  const confirmChange = async () => {
    const updatedDate =
      dayjs(selectedDate).format("YYYY-MM-DD") + "T00:00:00.000Z";

    const updatedRow = { ...selectedRowData, actualDate: updatedDate };

    let reqBody = {
      consultant_contractor: updatedRow?.consultant_contractor,
      pm: updatedRow.pm,
      plannedDate: updatedRow.plannedDate,
      actualDate: updatedRow?.actualDate,
      owned: updatedRow.owned,
      category: updatedRow.category,
      ProjectId: updatedRow?.projectId,
      id: updatedRow?.id,
      tag: updatedRow?.tag,
      project: updatedRow?.project,
      version: updatedRow?.version,
      updatedDate: updatedRow?.updatedDate,
      updatedby: updatedRow?.updatedby,
      workflowApprovalId: updatedRow?.workflowApprovalId
    };

    try {
      const formData = new FormData();
      formData.append("pandmJson", JSON.stringify({ ...reqBody }));
      const response = await editKeyPM({
        id: updatedRow?.id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(response?.message, "success");
        setDialogRowId(null);
        setSelectedRowId(null);
        setSelectedDate(null);
        refetch();
      } else {
        openNotification("Error in p-and-m updation");
      }
    } catch (error) {
      console.log("errr", error);
      openNotification(error?.data?.message, "error");
      setDialogRowId(null);
      setSelectedRowId(null);
      setSelectedDate(null);
    }
  };

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

  const handleActionView = (row) => {
    const encrypted = encrypt("view");
    navigate(`/projects/${projectId}/p&m-detail/${row?.id}/${encrypted}/false`);
  }

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" },
                width: { xs: '100%', sm: 'auto' },
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                // startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill: `${theme?.customSettings?.themeColor}` }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  const clearedValues = Object.fromEntries(
                    Object.keys(filters).map((key) => [key, ""])
                  );
                  setFilters(clearedValues);
                }}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        </Grid2>

        <Grid2
          sx={{
            width: {
              xs: '100%',
              sm: '500px',
              md: '500px',
              lg: '500px'
            }
          }}
        >
          <TextField
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by PM Name, PM ID"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <IoIosSearch /> */}
                  <SearchIcon style={{ height: "20px", width: "20px", fill: "#37352F", fillOpacity: 0.8 }} />
                </InputAdornment>
              ),
              style: {
                fontSize: "16px",
              },
              endAdornment: searchQuery?.length > 0 && (
                <IconButton onClick={clearSearch} edge="end">
                  {/* <ClearIcon style={{ fontSize: "16px" }} /> */}
                  <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080 " }} />
                </IconButton>
              ),
            }}
            fullWidth
            sx={{
              height: "48px",
              background: "#fff",
              "& .MuiInputBase-root": {
                height: "48px",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
            }}
          />
        </Grid2>


        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: pmViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={data}
            isLoading={isLoading}
            actionView={handleActionView}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allPM?.pagination?.currentPage || 1}
                totalPages={allPM?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
    </>
  );
};

export default AllPM;
